import { GetStaticProps } from 'next';
import Head from 'next/head';
import styled from 'styled-components';

import theme from '../assets/theme';
import HybridForm from '../components/_organisms/HybridForm/HybridForm';
import { NextPageWithLayout } from '../components/layouts';
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import { DefaultLocale } from '../providers/tolgee';

// HMH Into Reading lead-capture page: renders the shared HybridForm (role → organization →
// embedded Typeform) so Texas educators can request Curipod for their HMH Into Reading
// implementation. noindex + excluded from the sitemap (campaign landing page).
const HMHRequestPage: NextPageWithLayout = () => {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <LandingPageLayout
        title="Request Curipod for your Into Reading classrooms"
        ogTitle="HMH Into Reading Texas is your curriculum. Curipod brings engagement, writing, and insights."
        subTitle="Research-based writing practice including SCRs, ECRs, Revision & editing and more."
        disableHeadline={true}
      >
        <PageContainer>
          <Heading>Bring Curipod to your Into Reading classrooms</Heading>
          <Subtitle>
            Tell us a bit about your school or district and our team will show you how
            Curipod adds the engagement and insights layer to your HMH Into Reading
            implementation. We&apos;ll be in touch within one business day.
          </Subtitle>
          <HybridForm
            typeformUrl="https://form.typeform.com/to/ddl0Idmj?utm_source=curipod"
            metricEventNamePrefix="HMHIntoReadingRequest"
            curriculum="HMH"
            showTypeformEnding={true}
            thankYouMessage="Thanks — we got it! Someone from the Curipod team will reach out shortly about Curipod + HMH Into Reading for your classroom or district."
          />
        </PageContainer>
      </LandingPageLayout>
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      _tolgeeSSR: {
        language: DefaultLocale,
      },
    },
  };
};

export default HMHRequestPage;

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 20px 80px;
  background: ${theme.colors.background};

  @media (max-width: 992px) {
    padding: 24px 16px 60px;
  }
`;

const Heading = styled.h1`
  text-align: center;
  font-size: 36px;
  font-weight: 800;
  color: ${theme.colors.black};
  margin: 0 0 12px;
  max-width: 760px;

  @media (max-width: 992px) {
    font-size: 28px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

const Subtitle = styled.p`
  text-align: center;
  font-size: 16px;
  font-weight: 450;
  line-height: 1.45;
  color: ${theme.colors.text.dark};
  margin: 0 0 28px;
  max-width: 620px;
`;
